import { axiosInstance } from "../../axios/axiosInstance";
import { ADMIN_API_URL, getDefaultHeaders } from "../../config";

const authHeaders = () => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
  };
};

export const getAuditLogs = (params = {}) =>
  axiosInstance.get(`${ADMIN_API_URL}/get-audit-log`, {
    headers: authHeaders(),
    params,
  });

export const deleteAuditLogRequest = (id) =>
  axiosInstance.delete(`${ADMIN_API_URL}/delete-audit-log/${id}`, {
    headers: authHeaders(),
  });
